import { createContext } from 'react';

const OrgsMapContext = createContext({
  'org._id': {
    gatewayCount: 0,
    logo: 'org logo',
    name: 'org name',
    path: 'org path',
  },
});

export const OrgsMapProvider = OrgsMapContext.Provider;
export const OrgsMapConsumer = OrgsMapContext.Consumer;
export default OrgsMapContext;
